import styled, { css } from 'styled-components';
import {
  Box,
  SideSheetHeader,
  SideSheetClose,
  inputMediumStyles,
  IconStyled,
  ButtonAppearance,
  SideSheetBody,
} from '@bechtel/gds';
import { SearchField } from '@bechtel/client-common';
import { TextFieldStyled } from '@bechtel/client-weld-common';

export const HeaderStyled = styled(SideSheetHeader)`
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.white};
      color: ${theme.colors.grey[1000]};
      padding: ${theme.spacings[700]} ${theme.spacings[500]};
    `}
`;

export const CloseStyled = styled(SideSheetClose).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) =>
    css`
      color: ${theme.colors.bechtel.blue[800]};
      border: none;
      margin-top: ${theme.spacings[450]};
    `}
`;

export const SearchFieldComponentStyled = styled(SearchField)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
`;

export const SearchFieldStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '400' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  ${IconStyled} {
    right: ${({ theme }) => theme.spacings[500]};
  }
  ${TextFieldStyled} {
    ${({ theme }) => css`
      font-size: ${theme.fontSizes[400]};
      border-color: ${theme.colors.grey[300]};
      font-family: 'graphik';
    `}
  }
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;
export const StencilListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) =>
    css`
      flex-basis: 40%;
      box-shadow: 0 -3px ${theme.spacings[300]} 0 rgba(0, 0, 0, 0.16);
      background: ${theme.colors.white};
    `}
`;

export const ListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: '1' },
})`
  overflow-y: auto;
  height: 100%;
`;

export const SideSheetBodyStyled = styled(SideSheetBody)`
  ${({ theme }) => css`
    background: ${theme.colors.grey[100]};
  `}
`;
